import styled from 'styled-components';
import Form from 'react-bootstrap/Form';

export const IncentivesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1% 3%;
    font-size: 1rem;
    align-items: flex-start;
    margin: 10px 0;
    padding-bottom: 50px;
    text-align: left;

    @media only screen and (max-width: 600px) {
        align-items: center;
        margin-right: 0;
    }
`;

export const IncentiveContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: ${props => props.theme.ecoMint};
    border-radius: 8px;
    width: 100%;
    padding: 0 2% 2% 2%;
    margin-bottom: 15px;
    margin-top: 10px;

    @media only screen and (max-width: 600px) {
        padding-bottom: 15px;
        text-align: center;
    }
`;

export const IncentiveTitle = styled.h3`
    font-size: 1.15rem;
    color: ${props => props.theme.voltBlue};
    stroke: bold;
    padding: none;
    display: flex;
    margin-bottom: 0;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;

    button {
        padding: none;
        width: auto;
    }
`;

export const FlagButton = styled.button`
    border: 1px solid ${props => props.flagged ? 'red' : props.theme.voltBlue};
    color: white;
    font-size: 1.15rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    margin-left: 10px;
    font-size: 0.75rem;
    height: 30px;
    width: 50px;

    &:hover {
        border: 1px solid red;
    }
`

export const IncentiveLink = styled.a`
    color: ${props => props.theme.voltBlue};
    text-decoration: none;

    &:hover {
        color: ${props => props.theme.evTeal};
    }
`;

export const IncentiveBody = styled.div`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    text-align: left;
    display: ${props => props.expanded ? 'block' : 'none'};

    p {
        margin: 0.5rem;
    }
`;

export const IncentiveButton = styled.button`
    display: flex;
    flex-direction: row;
    width: 125px;
    background: none;
    border: none;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};

    &:hover {
        cursor: pointer;
        color: ${props => props.theme.evTeal};
    }
`;

export const SearchLine = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
`;

export const IncentiveSearch = styled(Form.Control)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    border-radius: 8px;
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;
`;

export const IncentiveSelect = styled(Form.Select)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    border-radius: 8px;
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
    }
    &:focus {
        border: 2px solid ${props => props.theme.ecoMint};
    }
`;

export const IncentiveSelectItem = styled.option`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    color: black;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
    }
`;

export const StyledCheckbox = styled.input`
    width: 20px;
    height: 20px;
    margin: 0 10px;
    accent-color: ${props => props.theme.evTeal};
    content: '';
`;

export const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;